module.exports = "images/brown.f9daa98695041c128aef07a58e7c6291.png";